import { forwardRef, useContext } from "react";
import ThemeContext from "config/context/themeContext";
import styles from "./InputField.module.css";

const InputField = forwardRef(
  ({ isValid = true, center = false, className, ...props }, ref) => {
    const { dark } = useContext(ThemeContext);

    return (
      <input
        className={`${className ?? ""} ${styles.inputField} ${
          !isValid ? styles.invalid : ""
        } ${dark ? styles.dark : ""} ${center ? styles.center : ""}`}
        ref={ref}
        {...props}
      />
    );
  },
);

export default InputField;
